import React, { useCallback } from 'react'

import { TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

function EmailField({
  value, canSubmit, onChange, onSubmit,
}) {
  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Enter' && canSubmit) {
      event.preventDefault()
      onSubmit()
    }
  }, [canSubmit, onSubmit])

  return (
    <TextInput
      id="ai-sign-in-email"
      type="primary"
      size="medium"
      label="Email"
      placeholder="john@email.com"
      value={value}
      onChange={onChange}
      onKeyDown={handleKeyDown}
      wrapperClassName="ai-sign-in-modal__field"
      aria-label="Email address"
      autoFocus
      isPilot
    />
  )
}

EmailField.propTypes = {
  value: string.isRequired,
  canSubmit: bool.isRequired,
  onChange: func.isRequired,
  onSubmit: func.isRequired,
}

export default EmailField
